import * as React from "react";

const SvgPhone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 449 449"
    style={{
      enableBackground: "new 0 0 449 449",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      d="M77 117s33.6-37 48.8-37c16.8 1.7 38.7 38.7 45.4 58.9 5 20.2-8.4 35.3-13.5 42-5 6.7-8.4 11.8-8.4 11.8 13.5 40.4 67.3 94.2 105.9 107.6 0 0 5-5 11.8-10.1 8.4-5 21.9-18.5 42-11.8 21.9 5 57.2 26.9 58.9 43.7 1.7 16.8-37 48.8-37 48.8C203.2 376 72 246.5 77 117z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
      }}
    />
  </svg>
);

export default SvgPhone;
